
import { useTranslation } from "react-i18next";

import EditUserHeader from "./EditUserHeader";
import EditUserPermissionsForm from './EditUserPermission.form';
import useEditUser from "./useEditUser";

import PermissionsSkeleton from "../../PermissionChecklist/Skeleton";

import EColourPanel from "../../../../../interfaces/EColourPanel";
import DynamicForm from "../../../../../yoello-lib/modules/dynamicForms/DynamicForms";
import useCanUserEditMerchant from "../../UserList/useCanUserEditMerchant";

const EditUserPermissions = (props: any) => {
  const { t } = useTranslation();

  const { onClose } = props;

  const { hasPermission, onFailedInteraction, isLoading: isCheckingCanEdit } = useCanUserEditMerchant(props.id);

  const { 
    user,
    isLoading,
    permissions,
    onSubmit,
    isSelf
  } = useEditUser({...props});

  return (
    <div>
      <EditUserHeader user={user} />
      {
        !isLoading && !isCheckingCanEdit ? 
          <DynamicForm
          onHandleSubmit={onSubmit}
          disableAll={!hasPermission}
          disableAllInteraction={onFailedInteraction}
          formData={{
            merchant_data: user,
            permissions: permissions,
            isSelf,
            isSuperuser: user.superuser
          }}
          formRows={EditUserPermissionsForm}
          formKeyName="confirm-email"
          useFormOptions={{
            reValidateMode: "onSubmit"
          }}
          isDialog={true}
          formButtons={{
            rightButton: isSelf ? 
              undefined : 
              {
                type: 'submit',
                label: "Submit",
                color: EColourPanel.PRIMARY,
                disabled: !hasPermission
              },
            leftButton: {
              type: 'button',
              label: t('delete.cancel'),
              onClick: onClose,
              color: EColourPanel.DEFAULT,
            }
          }}
        /> :
        <PermissionsSkeleton />
      }
    </div>
  );
};

export default EditUserPermissions;
